import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../styles/alerts.scss';
import SuccessIcon from './assets/success_message.svg';
import WarningIcon from './assets/warning_message.svg';
import ErrorIcon from './assets/error_message.svg';
import CloseIcon from './assets/close.svg';

class Alert extends Component {
    static propTypes = {
      message: PropTypes.string.isRequired,
      type: PropTypes.number.isRequired,
      status: PropTypes.bool.isRequired,
      setAlertStatus: PropTypes.func.isRequired,
    };

    state = {
      checkout: null,
    };


    componentDidMount() {
      this.handleSetTimeout();
    }

    componentWillUnmount() {
      this.setState({ checkout: null });
    }

    handleSetTimeout = () => {
      const { setAlertStatus } = this.props;
      this.state.checkout = setTimeout(() => {
        setAlertStatus(false);
      }, 7000);
      return () => clearTimeout(this.state.checkout);
    };

    handleBreakAlert = () => {
      const { setAlertStatus } = this.props;
      this.state.checkout = setTimeout(() => {
        setAlertStatus(false);
      }, 1);
      this.setState({ checkout: null });
      return () => clearTimeout(this.state.checkout);
    };

    handleGetTypeColor = (num) => {
      switch (num) {
        case 1: { return '#3be89d'; }
        case 2: { return '#fac83d'; }
        case 3: { return '#FF8080'; }
        default: { return null; }
      }
    };

    handleGetTypeMessage = (num) => {
      switch (num) {
        case 1: { return SuccessIcon; }
        case 2: { return WarningIcon; }
        case 3: { return ErrorIcon; }
        default: { return null; }
      }
    };

    render() {
      const {
        message, type, status,
      } = this.props;

      return (
        <div className="alert_container" style={{ backgroundColor: this.handleGetTypeColor(type), display: status ? 'block' : 'none' }}>
          <div className="alert_type">
            <div className="alert_name">
              <img src={this.handleGetTypeMessage(type)} style={{ width: 'auto', height: '20px' }} alt="" />
            </div>
            <div className="alert_message">
              <p> {message} </p>
            </div>
            <div className="close_alert_button">
              <button className="alert_button_close" onClick={() => this.handleBreakAlert()}>
                <img src={CloseIcon} style={{ width: 'auto', height: '15px' }} alt="" />
              </button>
            </div>
          </div>
        </div>
      );
    }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/AlertForm/Alert.js